import React from "react";

import { MANAGER_ROLE } from "../../consts/member";

import { getTimeDiffString } from "../../libs/dateFormat";
import { isArrayEmpty } from "../../libs/common";

import CommonProfile from "../MyInfo/Profile";

type Props = {
  nickname?: string;
  buildingName?: string;
  createdAt?: string;
  modifiedAt?: string;
  isCreator?: boolean;
  profile?: string;
  role?: string;
  isFaq?: boolean;
};

export default function UserProfile({
  nickname,
  buildingName,
  createdAt,
  modifiedAt,
  isCreator,
  profile,
  role,
  isFaq=false,
}: Props) {
  const roleList = role?.split(",");
  const isAdmin = roleList?.includes(MANAGER_ROLE.ADMIN);
  const isManager = !isArrayEmpty(
    roleList?.filter((item) => item !== MANAGER_ROLE.USER)
  );

  return (
    <div className="flex gap-1.5 items-center">
      <div className="min-w-[40px]">
        <CommonProfile src={profile} isAdmin={isAdmin} />
      </div>
      <div className="flex justify-between w-full">
        <div className="flex flex-col gap-2">
          <div className="flex gap-[5px] items-center">
            <div className=" text-sm font-semibold">{nickname}</div>
            {!isAdmin && isManager && <ProfileManagerIcon />}
            {isCreator && (
              <div className=" text-brand-primary-magenta text-sm">작성자</div>
            )}
          </div>
          {buildingName && (
            <div className="flex items-center gap-2 justify-between">
              <div className="flex items-center gap-1 text-neutral-500 text-xs">
                <ProfileLocation />
                {buildingName}
              </div>
            </div>
          )}
        </div>
        {(modifiedAt || createdAt) && !isFaq && (
          <div className=" text-[#999999] text-xs font-medium">
            {getTimeDiffString(modifiedAt || createdAt)}
            {modifiedAt ? " 수정됨" : ""}
          </div>
        )}
      </div>
    </div>
  );
}

export const ProfileManagerIcon = () => (
  <svg
    width="14"
    height="15"
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle opacity="0.9" cx="7" cy="7.5" r="7" fill="#E7E7E8" />
    <mask
      id="mask0_5567_51365"
      style={{ maskType: "luminance" }}
      maskUnits="userSpaceOnUse"
      x="2"
      y="3"
      width="10"
      height="6"
    >
      <path
        d="M2.83984 5.81974C2.83984 6.81793 3.63573 7.69162 4.82778 8.17849V5.32798H9.17357V5.9349H11.1575C11.1597 5.89711 11.1615 5.85842 11.1615 5.81974C11.1615 4.29244 9.29895 3.05371 7.00067 3.05371C4.70239 3.05371 2.83984 4.29244 2.83984 5.81974Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_5567_51365)">
      <path
        d="M11.1615 3.05371H2.83984V8.17849H11.1615V3.05371Z"
        fill="url(#paint0_linear_5567_51365)"
      />
    </g>
    <mask
      id="mask1_5567_51365"
      style={{ maskType: "luminance" }}
      maskUnits="userSpaceOnUse"
      x="2"
      y="6"
      width="10"
      height="6"
    >
      <path
        d="M9.17357 9.67257H4.82778V9.06521H2.84385C2.84118 9.10389 2.83984 9.14213 2.83984 9.18037C2.83984 10.7086 4.70283 11.9464 7.00067 11.9464C9.29851 11.9464 11.1615 10.7086 11.1615 9.18037C11.1615 8.18263 10.3656 7.30893 9.17357 6.82251V9.67257Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask1_5567_51365)">
      <path
        d="M11.1615 6.82251H2.83984V11.9464H11.1615V6.82251Z"
        fill="url(#paint1_linear_5567_51365)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_5567_51365"
        x1="2.83984"
        y1="6.54985"
        x2="9.41712"
        y2="5.43025"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EA27C2" />
        <stop offset="0.992254" stopColor="#E100A3" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_5567_51365"
        x1="2.83984"
        y1="10.318"
        x2="9.41706"
        y2="9.19826"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EA27C2" />
        <stop offset="0.992254" stopColor="#E100A3" />
      </linearGradient>
    </defs>
  </svg>
);

export const ProfileLocation = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.97868 14.0273L4.13533 10.3126C3.39381 9.58116 2.89224 8.65438 2.69349 7.64849C2.49475 6.64261 2.60768 5.6024 3.01814 4.6583C3.42859 3.71421 4.11829 2.90825 5.00075 2.34148C5.88321 1.77472 6.91915 1.47238 7.97868 1.47238C9.0382 1.47238 10.0741 1.77472 10.9566 2.34148C11.8391 2.90825 12.5288 3.71421 12.9392 4.65831C13.3497 5.6024 13.4626 6.64261 13.2639 7.64849C13.0651 8.65438 12.5635 9.58116 11.822 10.3126L7.97868 14.0273Z"
      fill="#B7B7B8"
      stroke="#B7B7B8"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.1733 6.93431C10.1733 8.14714 9.19011 9.13033 7.97728 9.13033C6.76444 9.13033 5.78125 8.14714 5.78125 6.93431C5.78125 5.72148 6.76444 4.73828 7.97728 4.73828C9.19011 4.73828 10.1733 5.72148 10.1733 6.93431Z"
      fill="white"
      stroke="white"
      strokeWidth="1.75"
    />
  </svg>
);
